import { render, staticRenderFns } from "./ClicModalFooter.vue?vue&type=template&id=dbde153e&"
import script from "./ClicModalFooter.vue?vue&type=script&lang=js&"
export * from "./ClicModalFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports